import { PasswordToggle } from "@/components/features";
import React from "react";
import { FaLock } from "react-icons/fa";
import { EditPasswordFormProps } from "../Types/types";

const FormEditPassword: React.FC<EditPasswordFormProps> = ({
  isFormValid,
  onSubmit,
  password,
  confirmPassword,
  passwordError,
  onPasswordChange,
  onConfirmPasswordChange,
  confirmPasswordError,
}) => {
  return (
    <form
      key="edit-password-form"
      className="flex flex-col gap-5 form-emerge"
      onSubmit={onSubmit}
    >
      {/* CONTRASEÑA */}
      <div className="relative p-0.5">
        <label className="text-lg font-bold block text-black">
          Contraseña Nueva <span className="text-[var(--color-error)]">*</span>
        </label>
        <div className="relative p-0.5">
          <PasswordToggle
            label="Contraseña"
            placeholder="Contraseña"
            required={true}
            name="password"
            value={password}
            onChange={onPasswordChange}
            className={`w-full pl-12 pr-4 py-3 border rounded-2xl text-xl bg-white focus:outline-none focus:ring-2 transition duration-300 text-gray-600 ${
              passwordError
                ? "border-red-500 focus:ring-red-400"
                : "border-gray-300 focus:ring-blue-400"
            }`}
          />
          <FaLock className="w-6 h-6 absolute left-4 top-1/2 -translate-y-3.5 text-gray-400 pointer-events-none" />
        </div>
        {passwordError && (
          <p className="mt-1 text-xs sm:text-sm text-[var(--color-error)] font-medium">
            {passwordError}
          </p>
        )}
      </div>

      {/* CONFIRMAR CONTRASEÑA */}
      <div className="relative p-0.5">
        <label className="text-lg font-bold block text-black">
          Confirma tu contraseña nueva{" "}
          <span className="text-[var(--color-error)]">*</span>
        </label>
        <div className="relative p-0.5">
          <PasswordToggle
            label="Confirmar Contraseña"
            placeholder="Confirmar Contraseña"
            required={true}
            name="confirmPassword"
            value={confirmPassword}
            onChange={onConfirmPasswordChange}
            disabled={!password || !!passwordError}
            className={`w-full pl-12 pr-4 py-3 border rounded-2xl text-xl bg-white focus:outline-none focus:ring-2 transition duration-300 text-gray-600 ${
              confirmPasswordError
                ? "border-red-500 focus:ring-red-400"
                : "border-gray-300 focus:ring-blue-400"
            } ${!password ? "bg-gray-100 cursor-not-allowed" : ""}`}
          />
          <FaLock className="w-6 h-6 absolute left-4 top-1/2 -translate-y-3.5 text-gray-400 pointer-events-none" />
        </div>
        {confirmPasswordError && (
          <p className="mt-1 text-xs sm:text-sm text-[var(--color-error)] font-medium">
            {confirmPasswordError}
          </p>
        )}
      </div>

      {/* BOTÓN */}
      <button
        type="submit"
        disabled={!isFormValid}
        className={`w-full py-3 sm:py-5 font-bold rounded-2xl text-xl transition duration-300 shadow-md ${
          isFormValid
            ? "bg-[var(--color-primary)] text-white hover:bg-[var(--color-primary-600)] hover:shadow-lg shadow-blue-400/30 cursor-pointer"
            : "bg-gray-300 text-gray-500 cursor-not-allowed shadow-gray-300/30"
        }`}
      >
        Restaurar Contraseña
      </button>
    </form>
  );
};

export default FormEditPassword;
